import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Form,
  FormGroup,
} from "reactstrap";
import "../login/mobileNumberVerification.css";
import { toastContainer } from "../../utils/toast";
import { connect } from "react-redux";
import * as url from "../../utils/url";
import axios from "../../axios";
import { withRouter } from "react-router";
import RegistrationResult from "../../components/RegistrationResult";
import RegistrationForm from "../../components/RegistrationForm";

const EmployeeNumberEntry = ({ history }) => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [submissionStatus, setSubmissionStatus] = useState(null);
  const [message, setMessage] = useState("");

  const isMobile = window.innerWidth < 768;

  const urlParams = new URLSearchParams(window.location.search);
  const orgId = urlParams.get("orgId");

  const handleTryAgain = () => {
    setSubmissionStatus(null);
    setMessage("");
    setPhoneNumber("");
    setFirstName("");
    setLastName("");
  };

  const handleSubmit = function(e) {
    e.preventDefault();
    if (phoneNumber && firstName && lastName && orgId) {
      const payload = {
        phoneNumber: phoneNumber,
        organizationId: orgId,
        firstName: firstName,
        lastName: lastName,
      };

      axios
        .post(url.qrCodePhoneSignup, payload)
        .then(({ data }) => {
          const status = data.data.status;
          if (status === "created") {
            setSubmissionStatus("success");
            setMessage("You’re all set! Your account has been created.");
          } else if (status === "already_registered") {
            setSubmissionStatus("already_registered");
            setMessage("You are already registered with this phone number.");
          } else {
            setSubmissionStatus("error");
            setMessage(
              "We’re unable to process your request at the moment. Please try again shortly."
            );
          }
        })
        .catch((err) => {
          const status = err.response.data.errors.message;
          if (status === "Invalid phone number format") {
            setSubmissionStatus("error");
            setMessage("The number you entered can not be used to register.");
          } else {
          console.error("Unexpected error:", err);
          setSubmissionStatus("error");
          setMessage("An unexpected error occurred.");
          }
        });
    } else {
      toastContainer(
        "Please enter your first name, last name, and a valid phone number.",
        "error"
      );
    }
  };

  return (
    <div
      className={` ${
        isMobile ? "mfa-setup--mobile mfa-setup--mobile-padding" : "mfa-setup"
      }`}
    >
      <Container className="mfa-container">
        <Row className="justify-content-center">
          <Col xs="12" sm="12" md="8" lg="5">
            <Card
              className={`mfa-card ${
                isMobile ? "border-0 shadow-none bg-transparent" : ""
              }`}
              style={
                isMobile
                  ? { maxHeight: "100vh", overflow: "hidden", width: "100%" }
                  : {}
              }
            >
              <CardBody
                style={{
                  padding: isMobile ? "20px" : "40px",
                  minHeight: isMobile ? "400px" : "450px",
                }}
              >
                {submissionStatus ? (
                  <RegistrationResult
                    status={submissionStatus}
                    message={message}
                    onTryAgain={handleTryAgain}
                  />
                ) : (
                  <RegistrationForm
                    phoneNumber={phoneNumber}
                    setPhoneNumber={setPhoneNumber}
                    firstName={firstName}
                    setFirstName={setFirstName}
                    lastName={lastName}
                    setLastName={setLastName}
                    onSubmit={handleSubmit}
                  />
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default connect()(withRouter(EmployeeNumberEntry));
